
    const data = {"name":"src/core/icons/home-group","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M17 16h-2v6h-3v-5H8v5H5v-6H3l7-6 7 6M6 2l4 4H9v3H7V6H5v3H3V6H2l4-4m12 1 5 5h-1v4h-3V9h-2v3h-1.66L14 10.87V8h-1l5-5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            